import * as R from 'ramda'
import Result from 'folktale/result'
import { mapProps, withState } from 'recompose'

const makePredicate = ([predFn, e]) => a => {
  let result = undefined

  try {
    result = predFn(a)
      ? Result.Ok(a)
      : Result.Error(e)
  } catch(error) {
    console.error(
      'Validation: Error in Predicate. Check if invalid value.',
      `value: ${a}`,
      error
    )
  }

  return result
}

const makePredicates = R.map(makePredicate)

const runPredicates = ([input, validations]) =>
  R.map(
    predFn => predFn(input),
    makePredicates(validations)
  )

const validate = R.compose(
  R.sequence(Result.of),
  R.reduce(R.concat, []),
  R.map(runPredicates),
)

const convertInputToArray = (inputs) => R.is(Array, inputs)
  ? inputs
  : R.of(inputs)

const makeValidationArray = (inputs, validations) =>
  R.map(
    input => [input, validations],
    convertInputToArray(inputs)
  )

const getKeys = (a, b) => R.intersection(
  R.keys(a),
  R.keys(b)
)

const mergeIntersection = R.converge(
  R.pick,
  [
    getKeys,
    R.mergeWith((l,r) => [l, r])
  ]
)

const getErrors = R.compose(
  R.map(([inputs, validations]) => getError(inputs, validations)),
  mergeIntersection
)

const getError = R.compose(
  validate,
  makeValidationArray
)

const displayResult = result => {
  // console.log(result)
  return (result.matchWith({
  Ok: _ => '',
  Error: ({ value }) => value
}))
}

const displayError = R.compose(
  displayResult,
  getError,
)

const displayErrors = (inputs, validations) => R.map(
  displayResult,
  getErrors(inputs, validations)
)

export {
  getError,
  getErrors,
  displayError,
  displayErrors,
}
